export default "__VITE_ASSET__9d1c7b38__"